import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Formik, Form } from "formik";
import { FormRow, FormRowMessage, FormTextbox, BlockButton, FormCheckbox } from "fiver-react-ui-components";
import schemaDeposit from "./schemaDeposit";

const Wrapper = ({
  translations,
  currencySymbol,
  getWallet,
  onError,
  balance,
  setTransactionsUpdated,
  myId
}) => {
  const [serverError, setServerError] = useState();

  const validate = values => {
    const errors = {};

    if (values.amount < 5 || values.amount > 200) {
      errors.amount = `${translations.errorDeposit.replace(/\$1/g, currencySymbol)}`;
    }

    return errors;
  };

  const onSubmit = async (values, {
    setSubmitting
  }) => {
    let depositRes;

    try {
      if (values.isFonix) {
        depositRes = await axios.post(`api/payment-gateway`, {
          payment_method: 1,
          amount: +values.amount * 100,
          user_id: myId
        });
      } else {
        depositRes = await axios.post(`/wallet/deposit`, {
          password: values.password,
          amount: +values.amount * 100
        });
      }

      setSubmitting(false);
      setServerError(undefined);
      setTransactionsUpdated(true);
      getWallet();
      toast.success(translations.depositSuccess);
      window.xtremepush("tag", "walletDeposit", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE,
        amount: values.amount
      }));
    } catch ({
      response
    }) {
      if (response?.code === 401) {
        onError(response);
      }

      if (response?.data?.errors) {
        if (response?.data?.errors?.amount) {
          setServerError(`${translations.amount} ${translations.invalid}`);
        } else if (response?.data?.errors?.password) {
          setServerError(`${translations.password} ${translations.invalid}`);
        }
      } else if (response?.data?.message === "This user has no payment source") {
        setServerError(translations.withdrawErrorNoCardAdded);
      } else if (response?.data?.message) {
        setServerError(response.data.message);
      } else {
        onError(response);
      }
    }

    window.xtremepush("tag", "Wallet.Withdraw");
  };

  return /*#__PURE__*/React.createElement(Formik, {
    validationSchema: schemaDeposit(translations),
    onSubmit: onSubmit,
    initialValues: {
      amount: "",
      password: "",
      isFonix: false
    },
    validate: validate
  }, ({
    isSubmitting,
    isValid,
    values,
    errors,
    dirty,
    handleChange,
    setFieldValue
    /* and other goodies */

  }) => /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    isError: errors.amount,
    onChange: e => {
      if (serverError) {
        setServerError(undefined);
      }

      handleChange(e);
    },
    value: values.amount,
    name: "amount",
    type: "tel",
    prefix: currencySymbol,
    placeholder: translations.amount
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: errors.amount
  }, errors.amount, errors.balance), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    isError: !errors.amount && !values.isFonix && errors.password,
    onChange: e => {
      if (serverError) {
        setServerError(undefined);
      }

      handleChange(e);
    },
    disabled: values.isFonix,
    value: values.password,
    name: "password",
    type: "password",
    placeholder: translations.password
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: !errors.amount && !values.isFonix && errors.password || serverError && isValid
  }, errors.password, serverError), /*#__PURE__*/React.createElement(BlockButton, {
    type: "submit",
    noDisabledStyles: true,
    disabled: !isValid || isSubmitting || !dirty,
    errorMessage: serverError,
    isLoading: isSubmitting,
    size: "sm"
  }, translations.deposit)));
};

export default Wrapper;